<script setup lang="ts">
import { CLASS_ROOT } from './constants'
import { AVAILABLE_LOCALES } from '/@src/plugins/i18n'
import { fixedLocale } from '/@src/app'
import { useWindowFocus } from '@vueuse/core'
import { useUserSession } from '/@src/stores/userSession'

const focused = useWindowFocus()
const userSession = useUserSession()
</script>

<template>
  <div :class="!focused && userSession.isLoggedIn ? 'gray' : '' + `${CLASS_ROOT}__brand`">
    <IDSKContainer>
      <IDSKRow>
        <IDSKCol>
          <IDSKHeaderGestor />
          <IDSKHeaderLanguageSwitcher
            v-if="!fixedLocale"
            :languages="AVAILABLE_LOCALES"
          />
        </IDSKCol>
      </IDSKRow>
    </IDSKContainer>
  </div>
</template>

<style scoped lang="scss">
.gray {
  background-color: #949494;
}
</style>
